export enum E_COMMERCE_OPERATIONS {
  addToBasket = 'add',
  removeFromBasket = 'removed',
  confirmOrder = 'purchase',
  viewProduct = 'detail'
}
